import { render } from "./welding_icon.vue?vue&type=template&id=9d1ad5a6"
import script from "./welding_icon.vue?vue&type=script&lang=js"
export * from "./welding_icon.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\benny\\Documents\\Programmieren\\Vue\\cellCalculator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__